import React from 'react';
import { ResidentialSolutions } from '../components/ResidentialSolutions';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation' | 'cinema';
interface ResidentialPageProps {
  onNavigate: (page: PageType) => void;
}
export function ResidentialPage({
  onNavigate
}: ResidentialPageProps) {
  return <main data-id="element-228">
      <ResidentialSolutions onNavigate={onNavigate} data-id="element-229" />
    </main>;
}